export default "__VITE_PUBLIC_ASSET__d9b9c356__"